export default "__VITE_ASSET__BkKNpN55__"